export default __webpack_public_path__ + "static/media/nftf.5ec5ad51.jpg";